import { Locales } from '@griply/types';
import { Locale } from 'date-fns';
import { da } from 'date-fns/locale/da';
import { de } from 'date-fns/locale/de';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { fr } from 'date-fns/locale/fr';
import { it } from 'date-fns/locale/it';
import { nb } from 'date-fns/locale/nb';
import { nl } from 'date-fns/locale/nl';
import { pl } from 'date-fns/locale/pl';
import { pt } from 'date-fns/locale/pt';
import { ptBR } from 'date-fns/locale/pt-BR';
import { sv } from 'date-fns/locale/sv';

// The datepicker registers every entry, the hooks resolve one, so both must read the same map:
// a new locale cannot be wired into one surface and silently missed by the other.
export const dateFnsLocaleMap: Record<Locales, Locale> = {
  [Locales.EnUS]: enUS,
  [Locales.NlNL]: nl,
  [Locales.DeDE]: de,
  [Locales.EsES]: es,
  [Locales.PlPL]: pl,
  [Locales.DaDK]: da,
  [Locales.SvSE]: sv,
  [Locales.NbNO]: nb,
  [Locales.ItIT]: it,
  [Locales.FrFR]: fr,
  [Locales.PtPT]: pt,
  [Locales.PtBR]: ptBR,
};

export const getDateFnsLocale = (language: Locales): Locale =>
  dateFnsLocaleMap[language] ?? dateFnsLocaleMap[Locales.EnUS];
